import React from "react"

import {useRecognitionAutomationQuery} from "@irati/recognition-automation/hooks"
import {Props} from "@irati/ui/src/IconText"
import Loading from "@irati/ui/src/Loading"
import {injectIntl} from "@irati/utils/lang"
import Create from "./Create"
const AutomationEdit: React.FC<Props> = (props) => {
  const {
    match: {params}
  } = props
  const {data: recognitionAutomation, loading: loadingRecognitionAutomation} = useRecognitionAutomationQuery({
    uuid: params.uuid
  })
  return (
    <Loading isLoading={loadingRecognitionAutomation}>
      {recognitionAutomation && <Create recognitionAutomation={recognitionAutomation} />}
    </Loading>
  )
}

export default injectIntl(AutomationEdit)
